import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { IftaLabelModule } from 'primeng/iftalabel';


@Component({
  selector: 'primeng-defaultlabel-wrapper',
  imports:[IftaLabelModule],
  template: `
    <div class="mb-2">
      <p-iftalabel>
        <ng-container #fieldComponent></ng-container>
        <label for="key">{{ props.label }}</label>
      </p-iftalabel>
    </div>
  `,
})
export class PrimeNGDefaultWrapper extends FieldWrapper {
}